export const ErrorCode = {
  TRP_VAL_008: 'TRP.VAL.008',
  TRP_VAL_009: 'TRP.VAL.009',
  TRP_VAL_010: 'TRP.VAL.010',
  TRP_VAL_011: 'TRP.VAL.011',
} as const;
export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
